import { PAGES } from "@dune/types";
import { MaterialToSubmissionFormData } from "@dune/types";
import { useEffect } from "react";
import { FormProvider } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { useAddMaterialParticipant } from "../../../../api/mutations/constructionSiteSubmission.mutations";
import { MaterialToSubmissionForm } from "../../../../component/constructionSites/submission/participants/MaterialToSubmissionForm";
import PageLayoutWithTabs from "../../../../component/layout/PageLayoutWithTabs";
import { useEntityPanelSync } from "../../../../hooks/useEntityPanelSync";
import { useMaterialToSubmissionForm } from "../../../../hooks/useParticipantToSubmissionForm";

export const AddMaterialToSubmissionPage = () => {
	const navigate = useNavigate();
	const { constructionSiteId } = useParams<{ constructionSiteId: string }>();

	const addMaterialMutation = useAddMaterialParticipant(
		constructionSiteId ? Number(constructionSiteId) : 0,
	);

	const onSubmit = (data: MaterialToSubmissionFormData) => {
		addMaterialMutation.mutate(data, {
			onSuccess: () => {
				navigate(-1);
			},
		});
	};

	const onCancel = () => {
		navigate(-1);
	};

	const { form, handleSubmit } = useMaterialToSubmissionForm({
		mode: "add",
		onSubmit,
	});

	useEntityPanelSync({
		entityType: "CONSTRUCTION_SITE",
		entityId: constructionSiteId ? Number(constructionSiteId) : 0,
	});

	useEffect(() => {
		if (!constructionSiteId) {
			navigate(PAGES.PROJECTS.index);
		}
	}, [constructionSiteId, navigate]);

	if (!constructionSiteId) {
		return null;
	}

	return (
		<PageLayoutWithTabs title="Ajouter un matériau">
			<FormProvider {...form}>
				<form onSubmit={handleSubmit}>
					<MaterialToSubmissionForm
						constructionSiteId={Number(constructionSiteId)}
						onSubmit={handleSubmit}
						onCancel={onCancel}
						isSubmitting={addMaterialMutation.isPending}
					/>
				</form>
			</FormProvider>
		</PageLayoutWithTabs>
	);
};
